import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

const base_api_url = "korankirimangratis";
const primaryKeys = ['page', 'limit', 'sortBy', 'sortDir',  'tgl1', 'tgl2', 'kota_id', 'kota_name', 'linetype', 'jurusan_id', 'jurusan_name', 'customer_id', 'CustName','kiriman_code','kiriman_name'];

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                let str = '';
                for (const key in obj) {
                    if (primaryKeys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${base_api_url}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(data){
        return new Promise(async (resolve, reject) => {
            try {
                // delete data.materials;
                const resp = await axios.post(`/${base_api_url}`,data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('kiriman gratis: ', obj.kirimanKey);
                const { data } = await axios.get(`/${base_api_url}/detail/${obj.kirimanKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detailGratis(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/${base_api_url}/detailgratis/${obj.kirimanKey}`);
                const list = data;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/${base_api_url}/${obj.kirimanKey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir'];
                for (const key in primaryKeys) {
                    if (primaryKeys.hasOwnProperty(key)) {
                        const element = primaryKeys[key];
                        keys.push(element)
                    }
                }
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/${base_api_url}/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'daftar_kiriman_gratisan.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
}